module.exports = __webpack_public_path__ + "img/clock-seven.1741d52f.svg";